import request from '@/utils/request'

export function saveAtt(data) {
  return request({
    url: 'ssoapi/sysuseratt/saveAtt',
    method: 'post',
    data: data,
  })
}

export function captchaImage(data) {
  return request({
    url: '/ssoapi/sysuseratt/captchaImage',
    method: 'post',
    data: data,
  })
}
// .输入金额查询换汇结果
export function exchangeQuery(data, option) {
  return request({
    url: '/transapi/info/exchangeQuery',
    method: 'post',
    data: data,
    ...option
  })
}

// .校验用户是否能够提现
export function checkLockRate(data) {
  return request({
    url: '/transapi/order/checkLockRate',
    method: 'post',
    data: data,
  })
}


// .用户首页获取滚动状态
export function checkHoneMessage(data) {
  return request({
    url: '/transapi/order/checkHoneMessage',
    method: 'post',
    data: data,
  })
}

// .国际化资源下发接口
export function getJsonResource(params) {
  return request({
    url: '/transapi/info/getJsonResource',
    method: 'get',
    params,
  })
}


// .H5获取暂停配置
export function getOrderPause(data) {
  return request({
    url: '/transapi/order/getOrderPause',
    method: 'post',
    data,
  })
}






// WEBPACK FOOTER //
// ./src/api/home.js